import React from 'react';
import Products from './Components/Home/dahlia.jsx';
import About from './Components/Home/Product.jsx';
import Footer from './Components/Home/Footer.jsx';
import ContactCard from './Components/Home/ContactCard_test.jsx';
import Events from './Components/Home/events.jsx';
import OverPTS from './Components/Home/Pts_xm.jsx';
import OurStory from './Components/Home/story.jsx';
import Financing from './Components/Home/Financing.jsx';
import Navbar2 from "./Components/Home/mainnav.jsx";

const HomePage = () => {
  return (
    <div className="container-fluid">
      <Navbar2 />
      <Products />
      <About />
      <OverPTS />
      <OurStory />
      <Financing />
      <Events />
      <ContactCard />
      <Footer />
    </div>
  );
}

export default HomePage;
